import { useSigning } from '../../Context'
import { BindingField } from './BindingField'
import { SigningFormFieldProps } from './Switcher'

export const EmailField = (props: SigningFormFieldProps) => {
  const signing = useSigning()

  return (
    <p
      style={{
        fontSize: 'inherit',
      }}
    >
      {signing.recipient.email}
    </p>
  )
}
